import { useTheme } from "@mui/material";

const ScoutMark = ({ size = 32, color }) => {
  const { palette } = useTheme();

  const topFill = color || palette.secondary.main;
  const middleFill = color || palette.primary.main;
  const bottomFill = color || palette.flights.main;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(-90 50 50)">
        <polygon points="20,21 70,21 80,36 30,36" fill={topFill} />
        <polygon points="30,42 80,42 70,57 20,57" fill={middleFill} />
        <polygon points="20,63 70,63 80,80 30,80" fill={bottomFill} />
      </g>
    </svg>
  );
};

export default ScoutMark;
